// frontend/src/components/TenantInvoiceSettingsTab.jsx
//
// Invoice settings, split into its own tab. Controlled/presentational: state and
// the save handler live in the parent (TenantInfoForm), passed in as props. Its
// Save button calls onSave, which PUTs the FULL tenant object (Option A) -- so
// saving here also persists the current company-info values, preventing the
// full-column backend update from blanking them.
//
// Retest focus: enable/disable invoices, prefix, notes -- save and reload.

import React from "react";

const TenantInvoiceSettingsTab = ({ formData, onChange, onSave }) => {
  const getInvoiceNumberPreview = () => {
    const prefix = formData.invoice_number_prefix || "INV";
    const now = new Date();
    const yearMonth = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
    return `${prefix}-${yearMonth}-001`;
  };

  return (
    <form onSubmit={onSave}>
      <h5 className="mb-3">
        <i className="bi bi-receipt me-2"></i>
        Invoice Settings
      </h5>

      <div className="mb-3">
        <div className="form-check form-switch">
          <input
            type="checkbox"
            className="form-check-input"
            id="enable_invoices"
            name="enable_invoices"
            checked={formData.enable_invoices}
            onChange={onChange}
            role="switch"
          />
          <label className="form-check-label" htmlFor="enable_invoices">
            <strong>Enable Invoice Generation</strong>
          </label>
        </div>
        <div className="form-text">
          When enabled, generates formal invoice summary PDFs in addition to
          supporting documentation. Includes invoice numbering, tax calculation
          inputs, and payment tracking.
        </div>
      </div>

      {formData.enable_invoices && (
        <div className="bg-light p-3 rounded mb-3">
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">Invoice Number Prefix</label>
              <input
                className="form-control"
                name="invoice_number_prefix"
                value={formData.invoice_number_prefix}
                onChange={onChange}
                placeholder="INV"
                maxLength="10"
              />
              <div className="form-text">
                Preview: <code>{getInvoiceNumberPreview()}</code>
              </div>
            </div>

            <div className="col-12">
              <label className="form-label">Invoice Notes</label>
              <textarea
                className="form-control"
                name="invoice_notes"
                value={formData.invoice_notes}
                onChange={onChange}
                rows="2"
                placeholder="Thank you for your business!"
                maxLength="500"
              />
              <div className="form-text">
                This message appears at the bottom of each invoice PDF (max 500
                characters)
              </div>
            </div>
          </div>

          <div className="alert alert-info mt-3 mb-0">
            <i className="bi bi-info-circle me-2"></i>
            <strong>Invoice Features Include:</strong>
            <ul className="mb-0 mt-2">
              <li>
                Sequential invoice numbering (
                {formData.invoice_number_prefix || "INV"}-YYYYMM-###)
              </li>
              <li>
                Formal invoice summary PDF (separate from supporting
                documentation)
              </li>
              <li>
                Tax input during invoice generation (service tax &amp; mileage
                tax)
              </li>
              <li>Payment tracking with partial payment support</li>
              <li>Invoice aging reports</li>
              <li>Status workflow: Generated &rarr; Sent &rarr; Partially Paid &rarr; Paid</li>
            </ul>
          </div>
        </div>
      )}

      <div className="d-grid gap-2 d-md-block mt-4">
        <button className="btn btn-primary" type="submit">
          <i className="bi bi-save me-2"></i>
          Save Invoice Settings
        </button>
      </div>
    </form>
  );
};

export default TenantInvoiceSettingsTab;